<template>
  <SearchSimple
    :value="$route.query.search"
    @submit="onSubmit"
  />
</template>

<script>
import { pick } from 'lodash'

import SearchSimple from '@/components/SearchSimple.vue'
import { displayParams } from '@/pages/manage.vue'

export default {
  name: 'ManageSearch',
  components: {
    SearchSimple,
  },
  methods : {
    onSubmit(val) {
      const queryPersist = pick(this.$route.query, displayParams)
      return this.$router.push({query: {search: val || undefined, ...queryPersist}})
    },
  },
}
</script>
